import { Container, Paper } from '@mantine/core'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { HomePage } from './HomePage'

export const App = () => {
    return (
        <Container>
            <Paper mt="lg" mb="lg" p="lg" shadow="md">
                <BrowserRouter>
                    <Routes>
                        <Route index element={<HomePage />} />
                    </Routes>
                </BrowserRouter>
            </Paper>
        </Container>
    )
}